import { Box, Button } from "@mui/material";
import React from "react";

export const FooterBlock = ({ setShowDetails }) => {
  return (
    <Box sx={{ height: "54px", ml: "auto", mt: "auto" }}>
      <Button
        sx={{
          fontSize: "18px",
          width: "240px",
          height: "54px",
        }}
        variant="contained"
        onClick={() => setShowDetails(null)}
      >
        Go back
      </Button>
    </Box>
  );
};
